<template>
  <PayoutForm @formSubmit="formSubmitted($event)" />
</template>

<script>
import store from "./PayoutStore";

import PayoutForm from "./PayoutForm.vue";
import PayoutMixin from "./PayoutMixin";

const responseStore = {
  response: null
};

export default {
  name: "PayoutNew",

  title () {
    return this.$t("payout.new") + ` - ${Dashboard.currentTenant.name}`;
  },

  components: {
    PayoutForm
  },

  mixins: [PayoutMixin],

  data: function () {
    return {
      responseStore: this.$_.cloneDeep(responseStore)
    };
  },

  methods: {
    async formSubmitted (e) {
      this.handleResponseToIndex(await store.create());
    }
  }
};
</script>
